import { render, staticRenderFns } from "./RequestDeletionAprovalSidebar.vue?vue&type=template&id=f4624296"
import script from "./RequestDeletionAprovalSidebar.vue?vue&type=script&lang=js"
export * from "./RequestDeletionAprovalSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports